import { render, staticRenderFns } from "./mail.vue?vue&type=template&id=3b49bcd7&scoped=true"
import script from "./mail.vue?vue&type=script&lang=js"
export * from "./mail.vue?vue&type=script&lang=js"
import style0 from "./mail.vue?vue&type=style&index=0&id=3b49bcd7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b49bcd7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b49bcd7')) {
      api.createRecord('3b49bcd7', component.options)
    } else {
      api.reload('3b49bcd7', component.options)
    }
    module.hot.accept("./mail.vue?vue&type=template&id=3b49bcd7&scoped=true", function () {
      api.rerender('3b49bcd7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/customerRecordManage/modelForm/mail.vue"
export default component.exports